export const setImageArray = (image) => ({
    type: 'SET_IMAGE_ARRAY',
    payload: image,
});